import cn from '@/lib/cn';

export default function BrandGradient({ className }: { className?: string }) {
  return (
    <svg
      className={cn(
        'pointer-events-none absolute -inset-1 -z-10 size-[calc(100%+0.5rem)]',
        className,
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      preserveAspectRatio="none"
      focusable="false"
      aria-hidden="true"
    >
      <g clipPath="url(#a)">
        <path
          fill="#1A253C"
          d="M0 0h100v100H0z"
        />
        <path
          fill="url(#b)"
          d="M0 0h124.896v222.037H0z"
          transform="translate(-12.448 -61.019)"
        />
        <path
          fill="url(#c)"
          d="M0 0h124.896v222.037H0z"
          transform="translate(-12.448 -61.019)"
        />
        <path
          fill="url(#d)"
          d="M0 0h100.09v99.829H0z"
          transform="translate(-.038 .074)"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="87.292"
          x2="-13.999"
          y1="186.898"
          y2="88.272"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#336ECC" />
          <stop
            offset="1"
            stopColor="#336ECC"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="c"
          x1="87.292"
          x2="-14.152"
          y1="34.583"
          y2="133.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#374E80" />
          <stop
            offset="1"
            stopColor="#374E80"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="d"
          x1="0"
          x2="100.09"
          y1="49.914"
          y2="49.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0B0F19" />
          <stop
            offset="1"
            stopColor="#1A253C"
            stopOpacity="0"
          />
        </linearGradient>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h100v100H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
